import { getJSON } from './http';

const list = () => getJSON('/moodle-ingestions');

export default {
  list,
};
